import { useQuery } from '@tanstack/react-query';

import { fetchProductsSummary } from '../data-provider/products-summary';
import type { GetProductSummaryRequestParams } from '../data-provider/products-summary/api';

export const useGetProductsSummary = (params: GetProductSummaryRequestParams) => {
  return useQuery({
    enabled: Boolean(params.shipmentKey),
    queryFn: () => fetchProductsSummary(params),
    queryKey: ['shipment-products-summary', params.shipmentKey],
  });
};
